import React, { FunctionComponent } from 'react';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconDiscipline: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faTags} />;

export { BrassIconDiscipline };
